import {
  CheckCircle,
  Medal,
  Rocket,
  Users,
} from "lucide-react";
import workingBg from "../../assets/images/Panda/red-panda-mascot-connecting-digital-network.png";
import ResponsiveImage from "../common/ResponsiveImage";

const aboutHighlights = [
  {
    title: "Cam kết",
    description:
      "Đồng hành xuyên suốt từ lúc phân tích nhu cầu đến khi hệ thống đi vào vận hành ổn định.",
    icon: Users,
  },
  {
    title: "Chất lượng",
    description:
      "Ưu tiên sản phẩm chỉn chu, rõ mục tiêu sử dụng và đủ tốt cho tăng trưởng dài hạn.",
    icon: Medal,
  },
  {
    title: "Sáng tạo",
    description:
      "Kết hợp tư duy thiết kế, kỹ thuật và bài toán kinh doanh để tạo ra giải pháp khác biệt.",
    icon: Rocket,
  },
  {
    title: "Uy tín",
    description:
      "Làm việc minh bạch về phạm vi, tiến độ và trách nhiệm để khách hàng dễ kiểm soát dự án.",
    icon: CheckCircle,
  },
];

const SectionIntroValue: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-[#fff8f8] to-white py-16 md:py-20">
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.92),rgba(255,245,245,0.98))]" />

      <div className="relative container">
        <div className="mx-auto max-w-[1180px]">
          <div className="grid items-start gap-8 lg:grid-cols-[0.88fr_1.12fr] lg:gap-8">
            <div className="space-y-4">
              <div className="relative overflow-hidden rounded-[26px] border border-red-100 bg-white/88 p-3 shadow-[0_20px_48px_rgba(127,29,29,0.08)] sm:p-4">
                <div className="rounded-[22px] border border-red-100/80 bg-[linear-gradient(180deg,#fffdfd_0%,#fff3f3_100%)] px-4 pt-6 sm:px-5 sm:pt-8">
                  <ResponsiveImage
                    src={workingBg}
                    alt="TrioCore Solutions working mascot"
                    className="mx-auto h-auto w-full max-w-[240px] object-contain sm:max-w-[280px] md:max-w-[310px]"
                  />
                </div>

                <div className="relative mt-4 rounded-2xl border border-red-100 bg-white/92 px-4 py-3 shadow-[0_10px_24px_rgba(127,29,29,0.08)] backdrop-blur-sm sm:absolute sm:bottom-6 sm:left-6 sm:right-6 sm:mt-0">
                  <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-red-700">
                    Enterprise Focus
                  </div>
                  <p className="mt-1 text-sm leading-6 text-gray-600">
                    Giải pháp số thực tế, rõ giá trị và đủ chắc cho hành trình phát triển của doanh
                    nghiệp.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-5">
              <span className="inline-flex w-fit items-center rounded-full border border-red-500/20 bg-red-50 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.15em] text-red-700">
                Về chúng tôi
              </span>

              <div className="max-w-[700px] space-y-3">
                <h2 className="text-[24px] font-semibold leading-[1.2] text-[#3f1717] sm:text-[27px] md:text-[30px] lg:text-[33px]">
                  TrioCore Solutions - Đối tác tin cậy trong hành trình{" "}
                  <span className="text-[#dc2626]">chuyển đổi số</span>
                </h2>
                <p className="max-w-[650px] text-[14px] leading-7 text-gray-600 md:text-[15px]">
                  Chúng tôi kiến tạo các giải pháp công nghệ rõ mục tiêu, kết hợp giữa tư duy thiết
                  kế hiện đại và nền tảng kỹ thuật đủ chắc để doanh nghiệp nâng cao hiệu quả vận
                  hành, tăng trưởng thương hiệu và mở rộng hệ thống một cách bền vững.
                </p>
              </div>

              <div className="grid gap-4 sm:grid-cols-2">
                {aboutHighlights.map(({ title, description, icon: Icon }) => (
                  <article
                    key={title}
                    className="rounded-[20px] border border-red-100 bg-white/90 p-4 shadow-[0_12px_28px_rgba(127,29,29,0.06)]"
                  >
                    <div className="mb-3 flex items-center gap-3">
                      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-[linear-gradient(135deg,#ef4444_0%,#b91c1c_100%)] text-white shadow-[0_8px_16px_rgba(220,38,38,0.14)]">
                        <Icon size={16}  />
                      </div>
                      <h3 className="text-[16px] font-semibold leading-tight text-[#2f1a1a] md:text-[17px]">
                        {title}
                      </h3>
                    </div>
                    <p className="text-[12.5px] leading-6 text-gray-600">{description}</p>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionIntroValue;
